import { fetchCurrentImmediateOrders, fetchInActiveItemsWithStock, fetchItemsWithoutInventoryAddress, fetchMustHaveItemsWithoutStock, fetchOrdersWithoutRoute, fetchPendingSpotCheckCount } from 'services';

/* eslint-disable @typescript-eslint/camelcase */
export const CONSTANTS = {
  APP_NAME: 'Producer-web',
  AUTH_TOKEN: 'PRODUCER_WEB_AUTH_TOKEN',
};

let PAGE_LIMIT = 50;
export const getPageLimit = () => {
  return PAGE_LIMIT;
};
export const updatePageLimit = (pageLimit: number) => {
  PAGE_LIMIT = pageLimit;
};

export const USER_ROLES = {
  PRODUCER: 'producer',
  OPERATOR: 'operator',
  MANAGER: 'manager',
  SUPERVISOR: 'supervisor',
  ADMIN: 'admin',
  PACKER: 'packer',
  SALES_PERSON: 'salesPerson',
};

export const MENU_ITEMS = [
  {
    url: '/orders',
    title: 'Orders',
    roles: [USER_ROLES.PACKER, USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/routes',
    title: 'Routes',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN, USER_ROLES.PACKER],
    hasChildren: false,
  },
  {
    url: 'https://torlanco.github.io/routes/app.html',
    title: 'Map Tool',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/pick-packs',
    title: 'Pick Packs',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN, USER_ROLES.PACKER],
    hasChildren: false,
  },
  {
    url: '/purchase-orders',
    title: 'Purchase Orders',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/available-tags',
    title: 'Available Tags',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/inventory-items',
    title: 'Inventory Items',
    roles: [USER_ROLES.PACKER, USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN, USER_ROLES.SALES_PERSON],
    hasChildren: false,
  },
  {
    url: '/suppliers',
    title: 'Suppliers',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    title: 'Reports',
    roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
    hasChildren: true,
    children: [
      {
        url: '/order-source-report',
        title: 'Order Source',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/refund-report',
        title: 'Refunds',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/inventory-item-sold-report',
        title: 'Sold Inventory Items',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/sales-channel-count-by-inventory-item-report',
        title: 'Sales Channel Count By Inventory Item',
        roles: [USER_ROLES.MANAGER, USER_ROLES.OPERATOR, USER_ROLES.ADMIN],
      },
      {
        url: '/supplier-invoice-report',
        title: 'Supplier Invoice Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/weight-avg-cost-report',
        title: 'Weight Average Cost',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/item-replenishment-report',
        title: 'Item Replenishment Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/discount-redemption-report',
        title: 'Discount Redemption Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/special-discount-report',
        title: 'Special Discount Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/inactive-inventory-item-with-stock',
        title: 'Inactive inventory item with stock',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/waiting-for-payment-order-report',
        title: 'Waiting For Payment Order Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/packers-speed-report',
        title: 'Packers Speed Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
      {
        url: '/sales-person-summary-report',
        title: 'Sales Person Summary Report',
        roles: [USER_ROLES.MANAGER, USER_ROLES.SUPERVISOR, USER_ROLES.ADMIN],
      },
    ],
  },
  {
    url: '/discounts',
    title: 'Discounts',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/category-groups',
    title: 'Category Groups',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/configs',
    title: 'Configs',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },

  {
    url: '/banners',
    title: 'Banners',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/media',
    title: 'Media',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/subscriptions',
    title: 'User Subscriptions',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/accounts',
    title: 'Accounts',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/users',
    title: 'Users',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/user-carts',
    title: 'User Carts',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/shopping-lists',
    title: 'Shopping Lists',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/units',
    title: 'Units',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/stripe-products',
    title: 'Stripe Products',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/cron-jobs',
    title: 'Cron Jobs',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/user-requested-items',
    title: 'User Requested Items',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/recipes',
    title: 'Recipes',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    title: 'Notification',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: true,
    children: [
      {
        url: '/send-push-notification',
        title: 'Send Push Notification',
        roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
        hasChildren: false,
      },
      {
        url: '/send-push-notification-audience',
        title: 'Send Push Notification To Audience',
        roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
        hasChildren: false,
      },
    ],
  },
  {
    url: '/actions',
    title: 'Actions',
    roles: [USER_ROLES.MANAGER, USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/home-page-collections',
    title: 'Home Page Collections',
    roles: [USER_ROLES.ADMIN],
    hasChildren: false,
  },
  {
    url: '/sales-channels',
    title: 'Sales Channels',
    roles: [USER_ROLES.ADMIN, USER_ROLES.SALES_PERSON],
    hasChildren: false,
  },
  {
    url: '/inventory-spot-check',
    title: 'Inventory Spot Check',
    roles: Object.values(USER_ROLES),
    hasChildren: false,
  },
];

export const MODAL_ENTITY = {
  ITEMS: 'items',
  ORDERS: 'orders',
};

export const DASHBOARD_ITEMS = [
  {
    itemHeaderName: 'Orders w/o Route',
    apiFunction: fetchOrdersWithoutRoute,
    color: 'green',
    action: {
      isActionModal: true,
      modalEntity: MODAL_ENTITY.ORDERS,
      isActionRoute: false,
    },
  },
  {
    itemHeaderName: 'Immediate Unfulfilled Orders',
    apiFunction: fetchCurrentImmediateOrders,
    color: 'green',
    action: {
      isActionModal: true,
      modalEntity: MODAL_ENTITY.ORDERS,
      isActionRoute: false,
    },
  },
  {
    itemHeaderName: 'Pending Spot Check',
    apiFunction: fetchPendingSpotCheckCount,
    color: 'orange',
    action: {
      isActionModal: false,
      isActionRoute: true,
      route: '/inventory-spot-check',
    },
  },
  {
    itemHeaderName: 'Inactive Items With Stock',
    color: 'blue',
    apiFunction: fetchInActiveItemsWithStock,
    action: {
      isActionModal: true,
      modalEntity: MODAL_ENTITY.ITEMS,
      isActionRoute: false,
    },
  },
  {
    itemHeaderName: 'Items w/o Inventory Address',
    apiFunction: fetchItemsWithoutInventoryAddress,
    color: 'blue',
    action: {
      isActionModal: true,
      modalEntity: MODAL_ENTITY.ITEMS,
      isActionRoute: false,
    },
  },
  {
    itemHeaderName: 'Must Have Items w/o Stock',
    apiFunction: fetchMustHaveItemsWithoutStock,
    color: 'blue',
    action: {
      isActionModal: true,
      modalEntity: MODAL_ENTITY.ITEMS,
      isActionRoute: false,
    },
  },
];

export const DATE_FORMATS = {
  MM_DD_YYYY_hh_mm_A: 'MM/DD/YYYY hh:mm a',
  MM_DD_YYYY: 'MM/DD/YYYY',
  MM_DD_YYYY___hh_mm_A: 'MM/DD/YYYY - hh:mm A',
  YYYY_MM_DD: 'YYYY-MM-DD',
  hh_mm: 'hh:mm',
  HH_mm: 'HH:mm',
  MM_dd_yyyy__EE_hh_mm_a: 'MM/dd/yyyy  EE hh:mm a',
};

export const PO_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  FULFILLED: 'FULFILLED',
  CANCELLED: 'CANCELLED',
  PARTIALLY_FULFILLED: 'PARTIALLY_FULFILLED',
  RECEIVED: 'RECEIVED',
  RE_OPENED: 'RE_OPENED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
};

export const AUDIENCE = {
  NEW_USERS: 'NEW_USERS',
  ACTIVE_USERS: 'ACTIVE_USERS',
  INACTIVE_USERS: 'INACTIVE_USERS',
  HIGH_REVENUE_USERS: 'HIGH_REVENUE_USERS',
};

export const ORDER_STATUS = {
  PENDING_PAYMENT: 'PENDING PAYMENT',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  PACKED: 'PACKED',
  UNPACKED: 'UNPACKED',
  DELIVERED: 'DELIVERED',
  REFUNDED: 'REFUNDED',
  PARTIAL_REFUNDED: 'PARTIAL_REFUNDED',
  CANCELLED: 'CANCELLED',
};

export const ORDER_ITEM_STATUS = {
  REFUNDED: 'REFUNDED',
  PACKED: 'PACKED',
};

export const ROUTE_STATUS = {
  DELIVERED: 'DELIVERED',
  PACKED: 'PACKED',
  PENDING: 'PENDING',
};

export const INVENTORY_HISTORY_STATUS_TYPE = {
  STATUS_CHANGE: 'STATUS_CHANGE',
  QUANTITY_CHANGE: 'QUANTITY_CHANGE',
  UNFULFILLED_QUANTITY_CHANGED: 'UNFULFILLED_QUANTITY_CHANGED',
};

export const phoneRegEx = /^$|^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const CONFIG_KEYS = {
  WORKING_DAYS_CONFIG: 'workingDaysConfig',
  AUTOMATIC_ROUTE_CONFIG: 'automaticRouteConfig',
};

export const USER_DETAILS_TYPE = {
  OVERVIEW: {
    key: 'overview',
    label: 'OVERVIEW',
  },
  ORDERS: {
    key: 'orders',
    label: 'ORDERS',
  },
  SUBSCRIPTIONS: {
    key: 'subscriptions',
    label: 'SUBSCRIPTIONS',
  },
  SUPPLIERS: {
    key: 'suppliers',
    label: 'SUPPLIERS',
  },
  USERS: {
    key: 'inventory',
    label: 'INVENTORY ITEMS',
  },
  HOME_BOX_PREFERENCES: {
    key: 'homeBoxPreferences',
    label: 'HOME BOX PREFERENCES',
  },
};

export const USER_SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  PAST_DUE: 'past_due',
  CANCELLED: 'canceled',
  UNPAID: 'unpaid',
  HOLD: 'hold',
};

export const INVENTORY_ITEM_PACKAGING_TYPE = [
  { name: 'BOLSA', value: 'BOLSA' },
  { name: 'each', value: 'each' },
  { name: 'SIN EMPAQUE', value: 'SIN EMPAQUE' },
  { name: 'BOLSA/MALLA', value: 'BOLSA/MALLA' },
  { name: 'SIN EMPAQUE 1 PIEZA', value: 'SIN EMPAQUE 1 pieza' },
  { name: 'PONER LABEL Y SU NOMBRE', value: 'poner label y su nombre' },
  { name: 'BOLSA PAPEL', value: 'BOLSA PAPEL' },
  { name: 'BOLSA PLASTICA', value: 'BOLSA/PLASTICA' },
  { name: 'GUARDAR EN NEVERA', value: 'guardar en nevera' },
  { name: 'WRAP', value: 'WRAP' },
  { name: 'GOMA', value: 'GOMA' },
  { name: 'CUIDADO PICA', value: 'CUIDADO PICA' },
  { name: 'YA VIENE EMPACADO', value: 'ya viene empacado' },
  { name: 'BOLSA/MALLA/SIN EMPAQUE', value: 'BOLSA/MALLA/SIN EMPAQUE' },
  { name: 'VERIFICAR ESTADO SIEMPRE/SIN EMPAQUE', value: 'verificar estado siempre/SIN EMPAQUE' },
  { name: 'EMPACAR EN BOLSA PLASTICA', value: 'empacar en bolsa plastica' },
];
export const CUTTING_TYPE = [
  { value: '', name: 'Choose a cutting Type' },
  { value: 'slice', name: 'slice' },
  { value: 'juiliene', name: 'juiliene' },
  { value: 'round', name: 'round' },
];

export const ORDER_BAG_TYPES = {
  PAPER_BAG: 'paperBag',
  PLASTIC_BAG: 'plasticBag',
  DELICATE_ITEM: 'delicateItem',
};


export const STRIPE_PRODUCT_TYPE = [
  { value: '', name: 'Choose a Type' },
  { value: 'homebox', name: 'Home Box' },
];

export const baseURL = process.env.REACT_APP_ADMIN_DASHBOARD_URL;

export const MODAL_TYPES = {
  SUCCESS: 'Success',
  CONFIRM_CHANGES: 'Confirm Changes',
};

export const LOCALES = [{ title: 'English', value: 'en' }];

export const ORDER_COURIER_DELIVERY_TYPES = {
  IMMEDIATE: 'IMMEDIATE',
  ROUTABLE: 'ROUTABLE',
};

export const TAG_TYPES = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  INVENTORY_ITEM: 'INVENTORY_ITEM',
};

export const DISCOUNT_TYPES = [
  { value: '', name: 'Choose a Type' },
  { value: 'FIXED_AMOUNT_OF_TOTAL', name: 'FIXED_AMOUNT_OF_TOTAL' },
  { value: 'PERCENTAGE_OF_DELIVERY', name: 'PERCENTAGE_OF_DELIVERY' },
  { value: 'PERCENTAGE_OF_TOTAL', name: 'PERCENTAGE_OF_TOTAL' },
  { value: 'FIXED_AMOUNT_OF_DELIVERY', name: 'FIXED_AMOUNT_OF_DELIVERY' },
  { value: 'FIXED_AMOUNT_OF_SUB_TOTAL', name: 'FIXED_AMOUNT_OF_SUB_TOTAL' },
  { value: 'PERCENTAGE_OF_SUB_TOTAL', name: 'PERCENTAGE_OF_SUB_TOTAL' },
];

export const PAYMENT_PROOF_OPTIONS = [{ value: '', name: 'Select a payment proof' }, { value: 'ach', name: 'ACH' }, { value: 'athMovil', name: 'ATH Movil' }, { value: 'check', name: 'Check' }, { value: 'creditCard', name: 'Credit Card' }, { value: 'other', name: 'Other' }];
export const PAYMENT_PROOF_OPTIONS_MAPPING = { 'ach': 'ACH', 'athMovil': 'ATH Movil', 'check': 'Check', 'creditCard': 'Credit Card', 'other': 'Other' };

export const SALES_CHANNELS = [
  {
    label: 'UVA',
    value: 'UVA',
  },
  {
    label: 'HOMEBOX',
    value: 'HOMEBOX',
  },
  {
    label: 'FACEBOOK',
    value: 'FACEBOOK',
  },
  {
    label: 'BULK',
    value: 'BULK',
  },
  {
    label: 'APP',
    value: 'APP',
  },
];

export const SUBSCRIPTION_TYPES = {
  WEEKLY: 'WEEKLY',
  BI_MONTHLY: 'BI_MONTHLY',
  MONTHLY: 'MONTHLY',
  TRI_WEEKLY: 'TRI_WEEKLY',
  DAILY: 'DAILY',
};

export const CATEGORIES_FOR_PICK_PACK_LIST = {
  TUBERCULOS: 'Tuberculos',
  HOJAS: 'Hojas',
  VEGETALES: 'Vegetales',
  FRUTAS: 'Frutas',
  HIERBAS: 'Hierbas',
};

export const DELIVERY_OPTIONS = ['Leave At Door', 'Meet At Door', 'Meet Outside'];

export const SALES_CHANNEL_TYPES = {
  UVA: 'UVA',
  UBER: 'UBER',
  INTERNAL_CHANNEL: 'INTERNAL_CHANNEL',
  SHOPIFY: 'SHOPIFY',
  DOORDASH: 'DOORDASH',
};

export const INVENTORY_QUANTITY_UPDATE_REASON = [
  { value: '', name: 'ALL' },
  { value: 'ITEM_SOLD', name: 'ITEM_SOLD' },
  { value: 'ORDER_CANCELLED', name: 'ORDER_CANCELLED' },
  { value: 'PO_FULFILLED', name: 'PO_FULFILLED' },
  { value: 'MANUAL_ADJUSTMENT', name: 'MANUAL_ADJUSTMENT' },
  { value: 'PO_ITEM_FULFILLMENT_CORRECTION', name: 'PO_ITEM_FULFILLMENT_CORRECTION' },
  { value: 'ITEM_REFUNDED', name: 'ITEM_REFUNDED' },
  { value: 'PO_RE_OPENED', name: 'PO_RE_OPENED' },
  { value: 'APPLY_ITEM_QUANTITY_CHANGES', name: 'APPLY_ITEM_QUANTITY_CHANGES' },
  { value: 'REVERT_ITEM_QUANTITY_CHANGES', name: 'REVERT_ITEM_QUANTITY_CHANGES' },
  { value: 'SPOT_CHECK', name: 'SPOT_CHECK' },
];

export const STRIPE_DASHBOARD_LINK = 'https://dashboard.stripe.com';

export const LOCALE = {
  ENGLISH: 'English',
  SPANISH: 'Spanish',
};